<script>
import { modalMethods, modalComputed } from '@state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...modalComputed,
  },
  mounted() {},
  methods: {
    ...modalMethods,
    close() {
      this.setSelectedImage(null);
      this.$bvModal.hide('fullsize-image-modal');
    },
  },
};
</script>

<template class="modal-item-select">
  <b-modal
    id="fullsize-image-modal"
    centered
    :hide-footer="true"
    size="lg"
    no-stacking
    @close="setSelectedImage(null)"
    @hidden="close"
  >
    <div v-if="selectedImage">
      <span v-if="selectedImage && selectedImage.pos">{{
        selectedImage.pos
      }}</span>
      <div
        class="img"
        :style="{ 'background-image': `url(${selectedImage.src})` }"
      ></div>
    </div>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';

.img {
  background-position: center;
  background-size: cover;
  height: 100vh;
}

.modal-body > div {
  border-radius: 2rem;
  max-height: 100%;
  overflow: scroll;
  width: 100%;
  span {
    background-color: rgba($color-black-wo-rgb, 0.5);
    border-bottom-right-radius: 2rem;
    border-top-left-radius: 2rem;
    color: white;
    font-size: 2rem;
    font-weight: 600;
    letter-spacing: 0.7px;
    padding: 1.5% 8%;
    position: absolute;
    text-transform: uppercase;
  }
}
</style>
